/*
 * @Author       : aa
 * @Date         : 2020-06-17 10:42:49
 * @Description  : 所有接口请求地址集合,方便以后维护
 * @FilePath     : \vue-gaokao-ebook\src\assets\api\apis.js
 * 
 * 路径后带 / 的,为restful传参
 * 不带 / 为的json
 * 
 */
const APIS = {
  //登录
  USER_LOGIN: "user/login",
  USER_LOGOUT: "user/logout",
  USER_LOGIN_BY_VERIFY_CODE: "user/login-mobile-verify-code",
  USER_ISLOGIN : "user/isLogon",
  USER_LOGIN_CODE : 'user/sms/verify-code',
  SET_RENEW_USER_BASIC_INFO: 'user/set-user-basic-info',
  SET_PASSWORD: 'user/set-password',
  WX_LOGIN_GET_CODE: 'user/get-user-by-weixincode',// 微信登录
  RESET_PASSWORD: 'user/reset-password',
  MOBILE_LOGIN: 'user/mobile-login-register',

  //注册
  USER_REGISTER_USERNAME_PASSWORD: "user/register-username",
  USER_REGISTER_PHONE_VERIFY_CODE: 'user/register-mobile',
  USER_REGISTER_PHONE_NEW: 'user/register-name-and-mobile',
  USER_REGISTER_SMS_CODE: "user/sms/register-verify-code",
  USER_REGISTER_SMS_CODE_NEW: "user/sms/register-name-and-mobile-verify-code",
  GET_TYPE_BY_PROVINCE: "user/get-gk-type/",//param 省份id 根据省份id获得高考类型
  USERNAME_EXISTS: "user/username-exists/",
  PHONE_EXISTS : "user/mobile-exists/",
  //试卷相关
  GET_PAPER_PREVIEW: 'gk/get-paper-preview',//预览
  GET_PAPERS_BY_SUBJECT_ID: "gk/get-papers-param", //根据科目id获取摸底考试列表
  GET_PAPERS_BY_NAV_ID : "gk/get-papers-navigationid",//根据科目id获取摸底考试列表
  GET_PAPERT_LAST : 'gk/get-papers-knowledge',//根据知识点id查询考试列表
  GET_PAPER_BY_ID : "gk/get-paper/",//获取
  GET_TEST_BY_USER_ID : "test/get-test-by-userid",//根据userid获取上一次测评
  PAPER_SUBMIT : "test/submit-test",//提交试卷
  PAPER_SAVE : "test/save-test",//保存试卷
  GET_ANSWER_PHOTO:"test/get-answer-files-Path",
  GET_LAST_PAPER : 'test/get-test-by-userid',//继续上次
  GET_KONEWLEDGE_POINT : 'motk/common/get-knowledge-point/',
  GET_KNOWLEDGE_POINT_BY_QUESTIONID : 'gk/get-knowledge-pointid-by-questionid',
  //基础夯实 和 专题强化的树
  GET_TREE_BY_GK_TYPE : 'navigation/get-erlun-navigation',//知识点列表,专题强化列表

  // 上传照片
  UPLOAD_PHTOT_FILLES: "/user/upload-files",
  UPLOAD_PHTOT: "/test/upload-answer-files",
  GET_ANSWER_FILES_PATH: "/test/get-answer-files-Path",
  GET_USER_ANSWER_FILES_PATH: "/user/upload-avatar-file",
  GET_PAPER_BY_ID : "gk/get-paper/",//根据试卷id获得试卷
  GET_TEST_ID : "test/get-test",//获得测试id
  // 个人中心
  GET_WRONG_BOOK_CLOSED : "/test/get-wrong-book-closed",// 查询归档错题本列表
  GET_WRONG_BOOK_UNCORRECTION : "/test/get-wrong-book-uncorrection",//根据科目id获取摸底考试列表
  GET_UNCOMPLETE: "/test/get-test-uncomplete", // 根据用户id查询未完成测评列表
  GET_AUDIT : "/test/get-test-audit", //根据用户id查询已评列表
  GET_UN_AUDIT : "/test/get-test-unaudit", // 未评列表
  GET_TEST_BY_TESTDETAIL: "/test/get-test-by-testid", // 自评 
  GET_QUESTION: "gk/get-question/",
  GET_TEST_RECORD: "/test/get-test-record", // 获取测评记录
  SET_USER_GK_INFO: "/user/set-user-gk-info",
  SUBMIT_TEST_QUESTION: '/test/submit-test-question',// 重做错题
  GET_GK_RESOURCE: '/test/get-gk-resource', // 精讲
  GET_ERLUN_NAVIGATION: 'navigation/get-erlun-navigation',
  GET_TEST_BY_QUESTIONID: '/test/get-test-by-questionid',
  GET_MOBILE_IS_BINDING: '/user/get-mobile-binding-code', 
  SET_BIND_MOBILE: '/user/bind-mobile',
  RELIEVE_BIND: '/user/relieve-bind/',
  GET_WX_BIND: '/user/is-bind-wx',
  SET_WX_BIND: '/user/bind-wx',
  RELIEVE_BIND_WX: '/user/relieve-bind-wx',
  MOBILE_IS_BINDING: '/user/mobile-is-binding',
  VIP_GET_ALL_BY_USERID: '/vip/card/get-all-by-userid',
  VIP_GET_USER_BY_USERID: '/vip/card/info/get-user-vip-card',
  VIP_GET_USER_BUY_PAPER: 'gk/get-user-buy-papers',
  VIP_ACTIVE_USER_SUBJECT: '/vip/user-relation/active-user-package-subjets',
  VIP_GET_PACKAGE_USER_TIME: '/vip/card/get-package-card-use-times',
  VIP_GET_ISCAN_INTO_PAPER: '/vip/card/get-iscan-into-paper',
  VIP_ADD_PACKAGE_PAPER_RECORD: '/vip/card/add-package-paper-record',
  VIP_MODIFY_PACKAGE_PAPER_RECORD: '/vip/card/modify-package-paper-record',
  VIP_GET_PACKAGE_CARD_INFO: '/vip/card/get-package-card-info',
  GET_ALL_ORDER : '/vip/order/get-order-info',
  // 专家测评
  GET_PAPERS_BY_SUBJECTID_DATETYPE: 'gk/get-papers-by-subjectId-dateType',
  GET_PAPER_PARAM: 'goods/get-papers-param',
  GET_PAPER_SUBJECTID_ANDROID: 'gk/get-papers-subjectid-android',
  GET_PAPER_SUBJECTID_PAPERS: 'gk/get-papers-param',
  GET_PAPER_DETAIL: 'gk/get-paper-details',
  // 客户端通关测试
  GET_PAPER_LIST_NAVI: 'tfj/paper/get-paper-list-by-navi-id',

  // 图片展示
  TEST_ANALYSIS_PROVINCE: 'gk/test-analysis-province', // 地图
  TEST_ANALYSIS_SCORE: 'gk/test-analysis-score',

  GET_EXPERT_EVALUATION_SUBJECTID: 'gk/get-expert-evaluation-subjectId',
  // 获取视频接口
  GET_GK_RESOURCE: '/test/get-gk-resource',
  // 获取banner图
  GET_TEST_POSTERS: 'gk/get-test-posters',

  // 错题本
  GET_WRONG_BOOK_TYPEIDS: '/test/get-wrong-book-typeIds', // 获取题型列表
  GET_WRONG_BOOK_KNOWLEDGEPOINTS: '/test/get-wrong-book-KnowledgePoints', // 知识点列表
  GET_WRONG_BOOK_PAPERS: '/test/get-wrong-book-papers',
  GET_VIDEO: '/resource/get-video-by-question-id',
  GET_WRONG_BOOK_EXAM_POINTS: '/test/get-wrong-book-exam-points', // 知识点列表
  
  // 支付相关接口
  CREATE_ORDER: '/alipay/create-order', // 生成订单
  ALIPAY_PAY:   '/alipay/pay',
  IS_HAVE_ORDER: '/alipay/is_have_order',
  QUERY_TRADE_STATUS: '/alipay/query-order-status',
  CREATE_WX_CODE_URL: '/wxpay/createPreOrder',

  // 会员相关接口
  GET_VIP_TYPE: '/vip/card/findall-type', // 获取vip种类接口
  SET_GOODS_ADDRESS: '/goods-address/add', // 增加收货地址
  SET_BILLING_ADD: '/billing/add', // 增加发票抬头
  //SET_MODIFY_BY_ORDERNUMBER: '/vip/order/modify-by-ordernumber' // 推广码接口
  SET_MODIFY_BY_ORDERNUMBER: '/vip/order/modify-code-by-ordernumber',

  GET_BY_CHAGEID: '/agent/get-by-chargeid',
  GET_CARD_DETAIL: '/vip/card/info/get-detail',
  GET_CARD_ACTIVE: '/vip/card/info/active-vip-card',
  GET_VIP_CARD_INFO: '/vip/card/info/get-user-vip-card',
  
  GET_CARD_INFOPAPER_NUM: '/vip/card/info/get-do-paper-num',
  GET_VIP_CARD_FIND: '/vip/card/find',
  GET_SCHOOL: 'city/get-school',
  GET_ALL_TERM: 'user/get-all-term',
  GET_ALL_GRADE: 'user/get-all-grade',

  // 添加账户余额支付接口
  GET_USER_BLANCE: 'sybpay/get-balance-by-userid',
  GET_BALANCE_RECORD: 'vip/order/get-balance-record',
  GET_GOODS_LIST: 'goods/get-pay-list',
  PAY_BALANCE: 'sybpay/balance-pay',
  PAY_BALANCE_PAPER: 'sybpay/balance-pay-for-paper',

  GET_PAPER_HAVDO: '/test/get-paper-havdo',
  GET_START_ANSWERING: '/test/evaluation/get-start-answering',
  GET_CHOOSE_WAY_ANSWER: '/test/evaluation/get-choose-way-answer',
  PUT_EVALUATION_SUBMIT_TEST: '/test/evaluation/submit-test',
  GET_LAST_TEST_BY_PAPERID_QUESTION_TYPE: '/test/get-last-test-by-paperid-question-type',
  GET_PAPER_TOTAL_REPORT_OLD: 'gk/get-paper-total-report',
  GET_PAPER_TOTAL_REPORT: 'gk/get-paper-last-report',
  GET_PAPER_TOTAL_SCORE: 'gk/get-paper-total-socre-rate',
  GET_NAVI_URL_BY: 'tfj/zres/get-navi-url-by', // 错题本获取资源
  GET_QUWSTION_OBTAIN: '/test/get-question-type-obtain-score-rate',
  GET_PAPER_STATISTICS: '/test/evaluation/get-paper-statistics',
  GET_TEST_LIST: '/test/get-test-list',
  FIND_MERGE_ORDER_CRITERIA: 'vip/order/find-merge-order-criteria',

  //提分秘籍
  GET_TFMJ_PLAY : '/marketing/marketing-play-tfmj-record',
  GET_TFMJ_VIDEOLIST : '/marketing/marketing-play-tfmj-resource'




}

export default APIS